<template>
  <div :style="'overflow-x: hidden;background:'+bgColor">	
      <div >
      		<div  class="banner-c"><img :src="imageConfig.imageList&&imageConfig.imageList[0].url"></div>
      </div>
	  <div class="crumbs-all">
		  <div class="crumbs-c"  v-if="lang==='zh'"><div @click="$router.push('/'+lang)" style="cursor: pointer;">首页 </div>> 关于我们</div>
		  <div class="crumbs-c" v-if="lang==='en'"><div @click="$router.push('/'+lang)" style="cursor: pointer;">Home </div> > About Us</div>
		  <div class="crumbs-c" v-if="lang==='ko'"><div @click="$router.push('/'+lang)" style="cursor: pointer;">첫 페이지 </div> > 우리</div>
		  <div class="crumbs-c" v-if="lang==='ja'"><div @click="$router.push('/'+lang)" style="cursor: pointer;">最初のページ  </div>> 私たちについて</div>
	  </div>
	  <div class="about-c content-bd" :style="'background:'+imageConfig.contentColor">
		<div class="f-l" :style="'background:'+imageConfig.categoryColor+';font-weight:600;color:#333'">
			<ul>
				<li :class="{on:currentType===0}" @click="getCompanyInfo(0)" v-if="lang==='zh'">集团概况<span></span></li>
				<li :class="{on:currentType===0}" @click="getCompanyInfo(0)" v-if="lang==='en'">About Us<span></span></li>
				<li :class="{on:currentType===0}" @click="getCompanyInfo(0)" v-if="lang==='ja'">会社概要<span></span></li>
				<li :class="{on:currentType!=0}" @click="getCompanyInfo(1)" v-if="lang==='zh'">集团历史<span></span></li>
				<li :class="{on:currentType!=0}" @click="getCompanyInfo(1)" v-if="lang==='en'">History<span></span></li>
				<li :class="{on:currentType!=0}" @click="getCompanyInfo(1)" v-if="lang==='ja'">グループ履歴<span></span></li>
			</ul>
		</div>
		<div class="f-r">
			<!-- <div  :style="'font-size:'+font.aboutTitleSize+';color:'+font.newsTitleColor+';margin: 20px;font-weight: 600;text-align: center;'">{{detailCompanyInfo.title}}</div> -->
			<div  v-html="detailCompanyInfo.content"> 
				
			</div>
		</div>
		<div class="clearfix"></div>
	  </div>
	  <p-bottom :lang="lang"></p-bottom>
  </div>
</template>

<script>
	
export default {
  name: 'About',
  props:{
  	lang:{}
  },
  data() {
    return {
      isCompany:true,
	  currentType:0,
	  imageConfig:{indexFirst:''},
	  detailCompanyInfo:{},
	  companyList:[],
	  font:{},
	  bgColor:'#fff'
    }
  },
  created(){
	  this.getImage()
	  this.getCompanyInfo(0)
	  this.getFontConfig()
  },
  methods: {
  	async getImage(){
		const res=await this.$http.post('aboutUsConfig',{la:this.lang})
		this.imageConfig = res.data[0]||{}
		this.bgColor = this.imageConfig.bgColor
	},
	handelBg(){
		if(localStorage.getItem('backgroudColor')){
			this.bgColor = JSON.parse(localStorage.getItem('backgroudColor')).newsBdColor
		}
	},
	selectItem(type){
		this.isCompany = type
		if(type){
			this.companyList.map(item=>{
				if(item.title.indexOf('概况')>-1){
					this.detailCompanyInfo = item
				}
			})
		}else{
			this.companyList.map(item=>{
				if(item.title.indexOf('历史')>-1){
					this.detailCompanyInfo = item
				}
			})
		}
	},
	async getCompanyInfo(type){
			const res  =  await this.$http.post('groupInfoList',{la:this.lang,type:type})
			this.detailCompanyInfo = res.data.find(v=>v.type===type)||{}
			this.currentType = type
	},
	async getFontConfig(){
		const res = await  this.$http.post('fontConfig')
		const fontContent = res.data
		if(fontContent.length!==0){
			this.font = fontContent[0]
			
		}
	}
  },
  watch: {
	// 如果路由有变化，会再次执行该方法
	"$route": "getCompanyInfo",

}
  
  
}
</script>
<style>
	.crumbs-all{
		background: #fff;
		border-bottom: 1px solid#f2f2f2;
	}
	.crumbs-all .crumbs-c{
		width: 1190px;
		margin: 0 auto;
		font-size: 16px;
		color: #333;
		height: 48px;
		line-height: 48px;
		display: flex;
		flex-direction: row;
	}
	.banner-c{
		position: relative;
		width: 100%;
		height: 460px;
		overflow: hidden;
	}
	.banner-c img{
		position: absolute;
		left:0;
		width:1920px;
		margin:0 calc(50% - 960px);
	}
	.about-c{
		background: #fff;	
	}
	.about-c .f-l{
		width: 300px;
		height: 430px;
		background: #fafafa;
		margin-left: 44px;
    	padding-top: 10px;
	}
	.about-c .f-l ul li{
		font-size: 17px;
		height: 65px;
		line-height: 65px;
		color: #666;
		padding: 0 58px;
		cursor: pointer;
	}
	.about-c .f-l ul li.on{
		background: #fff;
	}
	.about-c .f-l ul li:hover{
		background: #fff;
	}
	.about-c .f-l ul li span{
		background: url('../assets/images/news_arrow.jpg');
		display: block;
		width: 21px;
		height: 21px;
		float: right;
		margin-top: 22px;
	}
	.about-c .f-r{
		width: 736px;
		margin: 24px 40px 40px 40px;
		float: left;
	}
	.about-c .f-r img{
		width: 100%;
	}
</style>